<template>
  <section id="faq" class="faq-section">
    <v-container fluid>
      <!-- Título principal -->
      <v-col cols="12" class="text-center">
        <h1 class="font-weight-bold text-primary">Preguntas Frecuentes</h1>
        <p class="text-secondary">
          A continuación, respondemos algunas de las preguntas más comunes que
          pueden surgir sobre el sistema OSD.
        </p>
      </v-col>

      <!-- Lista de preguntas frecuentes -->
      <v-row>
        <v-col v-for="(item, index) in preguntas" :key="index" cols="12" md="6">
          <v-card class="faq-card">
            <v-card-title class="faq-card-title">{{
              item.pregunta
            }}</v-card-title>
            <v-card-text class="faq-card-text">{{
              item.respuesta
            }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  props: {
    preguntas: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.faq-section {
  background-color: transparent;
  padding: 30px 0;
  width: 80%;
  margin: 0 auto;
}

.text-primary {
  color: #9abe23; /* Verde primario */
  font-size: 2rem;
}

.text-secondary {
  color: #777;
  font-size: 1.1rem;
}

.faq-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  padding: 15px;
}

.faq-card-title {
  font-size: 1.1rem;
  font-weight: bold;
  color: #333;
}

.faq-card-text {
  font-size: 0.9rem;
  color: #555;
}

@media (max-width: 768px) {
  .text-primary {
    font-size: 1.5rem;
  }
  .text-secondary {
    font-size: 1rem;
  }
  .faq-card-title {
    font-size: 1rem;
  }
  .faq-card-text {
    font-size: 0.9rem;
  }
}
</style>
